<!-- src/app/modules/report-generator/components/layout/config-panel/config-panel.component.html -->
<div class="config-panel-overlay" [class.open]="isOpen">
  <div class="config-panel" (click)="$event.stopPropagation()">
    <div class="config-panel-header">
      <h3>Report Configuration</h3>
    </div>

    <div class="config-panel-content">
      <!-- Template Settings -->
      <div class="config-section">
        <h4>Template Settings</h4>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Select Template</mat-label>
          <mat-select
            #templateSelect
            [value]="getCurrentTemplateId()"
            (selectionChange)="onTemplateSelectionChange($event.value)">
            <mat-option 
              *ngFor="let template of templates" 
              [value]="template.id">
              {{ template.name }}
            </mat-option>
          </mat-select>
          <mat-hint>Choose from available report templates</mat-hint>
        </mat-form-field>
        
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Language</mat-label>
          <mat-select 
            [value]="reportConfig?.language || 'en'"
            (selectionChange)="onLanguageChange($event.value)">
            <mat-option value="en">English</mat-option>
            <mat-option value="de">German</mat-option>
            <mat-option value="es">Spanish</mat-option>
            <mat-option value="fr">French</mat-option>
            <mat-option value="nl">Dutch</mat-option>
          </mat-select>
          <mat-hint>Defaults to English (en) if the specified language does not have any content</mat-hint>
        </mat-form-field>

        <div class="action-buttons">
          <button 
            mat-raised-button 
            class="save-template-btn"
            (click)="onSaveTemplate()">
            <mat-icon class="small-icon">save</mat-icon>
            Save template
          </button>
          <button 
            *ngIf="showDeleteButton()"
            mat-raised-button 
            class="save-template-btn"
            (click)="onDeleteTemplate()">
            <mat-icon class="small-icon">delete</mat-icon>
            Delete template
          </button>
        </div>
        
      </div>
      
      <!-- Theme Settings -->
      <div class="config-section">
        <h4>Theme Settings</h4>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Select Theme</mat-label>
          <mat-select 
            [value]="getCurrentTheme()"
            (selectionChange)="onThemeChange($event.value)">
            <mat-option 
              *ngFor="let theme of themes" 
              [value]="theme.value">
              {{ theme.name }}
            </mat-option>
          </mat-select>
          <mat-hint>Choose from available report templates</mat-hint>
        </mat-form-field>
        <div class="color-input-group">
          <mat-form-field appearance="outline" class="color-field">
            <mat-label>Primary Color</mat-label>
            <input 
              matInput 
              type="color"
              [value]="reportConfig?.template?.theme?.colors?.primary || '#f44336'"
              (input)="onThemeColorChange('primary', $any($event.target).value)"
              class="color-input">
          </mat-form-field>
          <mat-form-field appearance="outline" class="color-field">
            <mat-label>Secondary Color</mat-label>
            <input 
              matInput 
              type="color"
              [value]="reportConfig?.template?.theme?.colors?.secondary || '#1cace5'"
              (input)="onThemeColorChange('secondary', $any($event.target).value)"
              class="color-input">
          </mat-form-field>
        </div>

        <!-- Extract colors from logo button -->
        <div class="action-buttons">
          <button 
            mat-raised-button 
            (click)="onExtractColors()"
            class="extract-colors-btn">
            <mat-icon class="small-icon">auto_fix_high</mat-icon>
            Extract from Logo
          </button>
          <button 
            mat-raised-button 
            (click)="swapColors()"
            class="extract-colors-btn">
            <mat-icon>swap_horiz</mat-icon>
            Swap
          </button>
        </div>
        
      </div>
      
      <!-- Template Info -->
      <div class="config-section">
        <h4>Current Template</h4>
        <div class="info-row">
          <span class="label">Name:</span>
          <span class="value">{{ reportConfig?.template?.name || 'None selected' }}</span>
        </div>
        <div class="info-row">
          <span class="label">Pages:</span>
          <span class="value">{{ reportConfig?.template?.pages?.length || 0 }}</span>
        </div>
        <div class="info-row" *ngIf="reportConfig?.template?.description">
          <span class="label">Description:</span>
          <span class="value">{{ reportConfig?.template?.description }}</span>
        </div>
      </div>

    </div>
  </div>
</div>